import { ChangeDetectionStrategy, Component, effect, inject, input, output } from '@angular/core';
import { GalleryDto } from '@nusign/picflow-backend-types';
import { GalleryService } from '../../../services/gallery.service';
import { GallerySettingsCustomizeHeaderComponent } from '../gallery-settings-customize-header/gallery-settings-customize-header.component';

@Component({
  selector: 'app-gallery-watermark-setting-customize',
  imports: [GallerySettingsCustomizeHeaderComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './gallery-watermark-setting-customize.component.html',
  styleUrls: ['./gallery-watermark-setting-customize.component.scss'],
})
export class GalleryWatermarkSettingCustomizeComponent {
  galleryService = inject(GalleryService);
  gallery = input.required<GalleryDto>();
  back = output<void>();

  constructor() {
    effect(() => {
      const gallery = this.gallery();
      if (!gallery) return;
    });
  }
}
